import getRandomInt from '../functions/getRandomInt';
import uqnJoin from '../functions/uqnJoin';
//import uqnSplit from '../functions/uqnSplit';
//import gcd from '../functions/gcd';
//import getRandomIntArray from '../functions/getRandomIntArray';
export default function random(type) {
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(1, 6); // 1-3: x^n, 4: x+1, 5: sqrt, 6: cuberoot
        while (type == 4) {
            type = getRandomInt(1, 6); // 1-3: x^n, 4: x+1, 5: sqrt, 6: cuberoot
        }
    }
    const directVsInverse = getRandomInt(0, 7);
    const k = getRandomInt(1, 9);
    const doubled = getRandomInt(0, 4);
    return uqnJoin([type, directVsInverse, k, doubled]);
}
